import { MODEL_KEY } from '../../model'
import { REDUX_LOCAL_KEY_PREFIX } from '../../redux/constants/local-key'

export const DAY_KEY = {
  ...MODEL_KEY,

  ORDER: 'order',
  NAME: 'name',
  TYPE: 'type',
  PLANNED_AT: 'plannedAt',

  // Associations
  WORKOUTS: 'workouts',
  QUOTES: 'quotes',
  ARTICLES: 'articles',
  MEDIA: 'media',

  // Foreign
  PLAN_ID: 'planId',
  PROFILE_ID: 'profileId',

  // Local
  CHALLENGE_STARTED_AT: `${REDUX_LOCAL_KEY_PREFIX}challengeStartedAt`

}

export const DAY_TYPE = {
  REST: 1
}

export const DAY_PRIVATE_KEYS = []
export const DAY_ASSOCIATION_KEYS = [
  DAY_KEY.WORKOUTS,
  DAY_KEY.MEDIA,
  DAY_KEY.QUOTES,
  DAY_KEY.ARTICLES
]

export const DAY_SCOPE = {

  /**
   * Only returns the public attributes of the Post.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: DAY_PRIVATE_KEYS
    }
  }

}

export const DAY_AUDIT = {
  CREATED: 'Day Created',
  UPDATED: 'Day Updated',
  DELETED: 'Day Deleted'
}

export const DAY_CLASS_NAME = 'Day'
